import { darken } from 'polished';
import { ButtonHTMLAttributes } from 'react';
import styled, { DefaultTheme } from 'styled-components';

export interface IButton {
  theme: DefaultTheme;
  compressed?: boolean;
  rounded?: boolean;
  hollow?: boolean;
  secondary?: boolean;
  fullWidth?: boolean;
}

const Button = styled.button<IButton & ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ theme, compressed, fullWidth, rounded, hollow, secondary }) => {
    const { color, type } = theme;

    const variantColor = secondary ? color.grayscale[0] : color.primary.regular;

    return `
      font-size: ${type.size.small};
      font-weight: ${type.weight.regular};
      color: ${hollow ? variantColor : color.grayscale[1000]};
      background-color: ${hollow ? color.grayscale[1000] : variantColor};
      border: 1px solid ${hollow ? variantColor : 'transparent'};
      border-radius: ${rounded ? '27px' : '8px'};
      padding: ${compressed ? '7px 16px' : '15px 24px'};
      line-height: 1;
      cursor: pointer;
      ${fullWidth === true ? 'width: 100%;' : ''}

      &:not(:disabled):hover {
        color: ${color.grayscale[1000]};
        background: ${
          hollow ? variantColor : `linear-gradient(180deg, ${darken(0.1, variantColor)} 0%, ${variantColor} 100%)`
        };
      }

      &:not(:disabled):active {
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      &:disabled {
        cursor: not-allowed;
        background-color: ${color.grayscale[200]};
      }
    `;
  }
);

export default Button;
